module.exports = __webpack_public_path__ + "static/media/banner_CBD@2x.6f641679.png";